import { Dispatch, ThunkAction } from '../../../types/actions';
import { TBoardId } from '../../../types/types';
import { boardUpdateMeta } from './boardUpdateMeta';

export const boardSetDefaultStartDateTimeMeta = (
    boardId: TBoardId,
    defaultStartDateTime: Date
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        return dispatch(boardUpdateMeta(boardId, { defaultStartDateTime }));
    };
    return action;
};
